import React, { memo, useMemo } from 'react';
import classnames from 'classnames/bind';
import { Text } from "../Text";
import styles from "./styles.pcss";
var cn = classnames.bind(styles);
export var FileDownloader = /*#__PURE__*/memo(function (_ref) {
  var _ref$testName = _ref.testName,
    testName = _ref$testName === void 0 ? 'FileDownloader' : _ref$testName,
    text = _ref.text,
    href = _ref.href,
    _ref$textSize = _ref.textSize,
    textSize = _ref$textSize === void 0 ? 'size6-r' : _ref$textSize,
    _ref$isWithButton = _ref.isWithButton,
    isWithButton = _ref$isWithButton === void 0 ? true : _ref$isWithButton;
  var extensionType = useMemo(function () {
    if (isWithButton) {
      var wordsArray = href.split('.');
      return wordsArray[wordsArray.length - 1];
    }
    return '';
  }, [href, isWithButton]);
  return /*#__PURE__*/React.createElement("a", {
    className: cn('file-downloader'),
    "data-component": testName,
    download: true,
    href: href,
    "data-t-id": "src-FileDownloader"
  }, isWithButton && /*#__PURE__*/React.createElement("div", {
    className: cn('file-downloader__button')
  }, /*#__PURE__*/React.createElement(Text, {
    isUpperCase: true,
    size: "size6-r"
  }, extensionType)), /*#__PURE__*/React.createElement("div", {
    className: cn('file-downloader__text')
  }, /*#__PURE__*/React.createElement(Text, {
    color: "inherit",
    size: textSize
  }, text)));
});
FileDownloader.displayName = FileDownloader.name;